import React from "react";
import Table from "react-bootstrap/Table";
import MetricFormatter from "dashboards/MetricFormatter";
import getCurrencyDetails from "utils/getCurrencyDetails";

class SEOSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTable: "ecommerce",
    };
  }

  render() {
    let clients = Object.keys(this.props.metrics);
    const firstKey = clients[0];
    const metrics = Object.keys(this.props.metrics[firstKey]).filter((el) => !el.includes("yy"));
    const leadgenList = this.props.client_list.filter((el) => el["account_type"] == "leadgen").map((item) => item);
    const leadgenClients = leadgenList.map((item) => item.client_name);
    const ecommerceList = this.props.client_list.filter((el) => el["account_type"] == "ecommerce").map((item) => item);
    const ecommerceClients = ecommerceList.map((item) => item.client_name);
    let totals = {
      leadgen: {},
      ecommerce: {},
    };

    leadgenClients.map((client) => {
      metrics.map((metricName) => {
        let mValue = this.props.metrics[client][metricName];
        totals["leadgen"][metricName] ? (totals["leadgen"][metricName] += mValue) : (totals["leadgen"][metricName] = mValue);
      });
    });

    ecommerceClients.map((client) => {
      metrics.map((metricName) => {
        let mValue = this.props.metrics[client][metricName];
        totals["ecommerce"][metricName] ? (totals["ecommerce"][metricName] += mValue) : (totals["ecommerce"][metricName] = mValue);
      });
    });

    totals["leadgen"]["revenue_mtd_yy"] =
      ((totals["leadgen"]["revenue_mtd"] - totals["leadgen"]["revenue_mtd_last_year"]) / totals["leadgen"]["revenue_mtd_last_year"]) * 100;
    totals["leadgen"]["revenue_this_month_yy"] =
      ((totals["leadgen"]["revenue_this_month_projected"] - totals["leadgen"]["revenue_this_month_last_year"]) /
        totals["leadgen"]["revenue_this_month_last_year"]) *
      100;
    totals["leadgen"]["traffic_mtd_yy"] =
      ((totals["leadgen"]["traffic_mtd"] - totals["leadgen"]["traffic_mtd_last_year"]) / totals["leadgen"]["traffic_mtd_last_year"]) * 100;
    totals["leadgen"]["traffic_this_month_yy"] =
      ((totals["leadgen"]["traffic_this_month_projected"] - totals["leadgen"]["traffic_this_month_last_year"]) /
        totals["leadgen"]["traffic_this_month_last_year"]) *
      100;

      console.log(totals)

    totals["ecommerce"]["revenue_mtd_yy"] =
      ((totals["ecommerce"]["revenue_mtd"] - totals["ecommerce"]["revenue_mtd_last_year"]) / totals["ecommerce"]["revenue_mtd_last_year"]) * 100;

      console.log(totals)

    totals["ecommerce"]["revenue_this_month_yy"] =
      ((totals["ecommerce"]["revenue_this_month_projected"] - totals["ecommerce"]["revenue_this_month_last_year"]) /
        totals["ecommerce"]["revenue_this_month_last_year"]) * 100;

    totals["ecommerce"]["traffic_mtd_yy"] =
      ((totals["ecommerce"]["traffic_mtd"] - totals["ecommerce"]["traffic_mtd_last_year"]) / totals["ecommerce"]["traffic_mtd_last_year"]) * 100;

    totals["ecommerce"]["traffic_this_month_yy"] =
      ((totals["ecommerce"]["traffic_this_month_projected"] - totals["ecommerce"]["traffic_this_month_last_year"]) /
        totals["ecommerce"]["traffic_this_month_last_year"]) * 100;

    const changeTable = (table) => {
      this.setState({ activeTable: table });
    };

    return (
      <>
        <div className={"summary-buttons"}>
          <div>
            <p>Client Type:</p>
          </div>
          <div className="sb-container">
            <button
              className={this.state.activeTable == "ecommerce" ? "summary-button active" : "summary-button inactive"}
              onClick={() => {
                changeTable("ecommerce");
              }}>
              Ecommerce
            </button>
          </div>
          <div className="sb-container">
            <button
              className={this.state.activeTable == "leadgen" ? "summary-button active" : "summary-button inactive"}
              onClick={() => {
                changeTable("leadgen");
              }}>
              Lead Gen
            </button>
          </div>
        </div>
        <div className="row styled-indent-green">
          <div className="col-12 pt-1 pl-3">
            <div className="no-gutters clear-both off-color-bg show py-4 px-0 px-md-4">
              <div className="mb-2 table-responsive">
                {this.state.activeTable == "ecommerce" ? (
                  <Table striped className="mt-2 table-white table-striped table-striped-summary metric-table">
                  <thead>
                    <tr>
                      <th className="client-cell client-head" style={{ border: "none" }}>
                        Client
                      </th>
                      <th style={{ border: "none" }} colSpan="3" className="bg-transparent" key="Revenue MTD">
                        <div className="d-flex justify-content-center">Revenue {this.props.this_month} MTD</div>
                      </th>
                      <th style={{ border: "none" }} colSpan="3" className="bg-transparent" key="Revenue Projected">
                        <div className="d-flex justify-content-center">Revenue {this.props.this_month} Y/Y</div>
                      </th>
                      <th style={{ border: "none" }} colSpan="3" className="bg-transparent" key="Traffic MTD">
                        <div className="d-flex justify-content-center">Organic Traffic {this.props.this_month} MTD</div>
                      </th>
                      <th style={{ border: "none" }} colSpan="3" className="bg-transparent" key="Traffic Projected">
                        <div className="d-flex justify-content-center">Organic Traffic {this.props.this_month} Projected Y/Y</div>
                      </th>
                    </tr>
                    <tr className="client-cell client-head">
                      <th className="client-cell client-head" style={{ backgroundColor: "#E1E1E1" }}></th>
                      {[1, 2, 3, 4].map((index) => {
                        return (
                          <React.Fragment key={index}>
                            <th className="bg-white bg-white-border" style={{ border: "1px solid rgb(225, 225, 225)" }}>
                              {this.props.date.substring(0, 4)}
                            </th>
                            <th className="bg-white bg-white-border" style={{ border: "1px solid rgb(225, 225, 225)" }}>
                              {parseInt(this.props.date.substring(0, 4)) - 1}
                            </th>
                            <th className="bg-white bg-white-border" style={{ border: "1px solid rgb(225, 225, 225)" }}>
                              Y/Y
                            </th>
                          </React.Fragment>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {ecommerceClients.map((clientName) => {
                      return (
                        <tr key={clientName}>
                          <td className="client-cell" style={{ textAlign: "left", fontWeight: "900" }}>
                            {clientName}
                          </td>
                          {[
                            "revenue_mtd",
                            "revenue_mtd_last_year",
                            "revenue_mtd_yy",
                            "revenue_this_month_projected",
                            "revenue_this_month_last_year",
                            "revenue_this_month_yy",
                            "traffic_mtd",
                            "traffic_mtd_last_year",
                            "traffic_mtd_yy",
                            "traffic_this_month_projected",
                            "traffic_this_month_last_year",
                            "traffic_this_month_yy",
                          ].map((metricName) => {
                            let className = "";
                            let value = this.props.metrics[clientName][metricName];
                            if (metricName.includes("yy")) {
                              if (value > 0) {
                                className = "bg-success text-white font-weight-bold";
                              } else if (value < 0) {
                                className = "bg-danger text-white font-weight-bold";
                              }
                            }
                            return (
                              <td key={metricName} className={className}>
                                {value != 0 ? (
                                  metricName.includes("yy") ? (
                                    <MetricFormatter.YY displayCurrency={this.props.currency} value={value} />
                                  ) : metricName.includes("revenue") ? (
                                    <MetricFormatter.Revenue displayCurrency={this.props.currency} value={value} />
                                  ) : (
                                    <MetricFormatter.Sessions value={value} />
                                  )
                                ) : (
                                  <></>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                    <tr>
                      <td className="client-cell" style={{ borderTop: "1px solid darkgrey", textAlign: "left", fontWeight: "900" }}>
                        TOTALS
                      </td>
                      {[
                        "revenue_mtd",
                        "revenue_mtd_last_year",
                        "revenue_mtd_yy",
                        "revenue_this_month_projected",
                        "revenue_this_month_last_year",
                        "revenue_this_month_yy",
                        "traffic_mtd",
                        "traffic_mtd_last_year",
                        "traffic_mtd_yy",
                        "traffic_this_month_projected",
                        "traffic_this_month_last_year",
                        "traffic_this_month_yy",
                      ].map((metricName) => {
                        let className = "";
                        let value = totals["ecommerce"][metricName];
                        if (metricName.includes("yy")) {
                          if (value > 0) {
                            className = "bg-success text-white font-weight-bold";
                          } else if (value < 0) {
                            className = "bg-danger text-white font-weight-bold";
                          }
                          className =  value == 0 || value == Infinity || value == -Infinity ? "" : className;
                        }
                        return (
                          <td style={{ borderTop: "1px solid darkgrey" }} key={metricName} className={className}>
                            {value != 0 ? (
                              metricName.includes("yy") ? (
                                <MetricFormatter.YY displayCurrency={this.props.currency} value={value} />
                              ) : metricName.includes("revenue") ? (
                                <MetricFormatter.Revenue displayCurrency={this.props.currency} value={value} />
                              ) : (
                                <MetricFormatter.Sessions value={value} />
                              )
                            ) : (
                              <></>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </Table>
                ) : (
                  <Table striped className="mt-2 table-white table-striped table-striped-summary metric-table">
                    <thead>
                      <tr>
                        <th className="client-cell client-head" style={{ border: "none" }}>
                          Client
                        </th>
                        <th style={{ border: "none" }} colSpan="3" className="bg-transparent" key="Conversions MTD">
                          <div className="d-flex justify-content-center">Conversions {this.props.this_month} MTD</div>
                        </th>
                        <th style={{ border: "none" }} colSpan="3" className="bg-transparent" key="Conversions Projected">
                          <div className="d-flex justify-content-center">Conversions {this.props.this_month} Y/Y</div>
                        </th>
                        <th style={{ border: "none" }} colSpan="3" className="bg-transparent" key="Traffic MTD">
                          <div className="d-flex justify-content-center">Organic Traffic {this.props.this_month} MTD</div>
                        </th>
                        <th style={{ border: "none" }} colSpan="3" className="bg-transparent" key="Traffic Projected">
                          <div className="d-flex justify-content-center">Organic Traffic {this.props.this_month} Projected Y/Y</div>
                        </th>
                      </tr>
                      <tr className="client-cell client-head">
                        <th className="client-cell client-head" style={{ backgroundColor: "#E1E1E1" }}></th>
                        {[1, 2, 3, 4].map((index) => {
                          return (
                            <React.Fragment key={index}>
                              <th className="bg-white bg-white-border" style={{ border: "1px solid rgb(225, 225, 225)" }}>
                                {this.props.date.substring(0, 4)}
                              </th>
                              <th className="bg-white bg-white-border" style={{ border: "1px solid rgb(225, 225, 225)" }}>
                                {parseInt(this.props.date.substring(0, 4)) - 1}
                              </th>
                              <th className="bg-white bg-white-border" style={{ border: "1px solid rgb(225, 225, 225)" }}>
                                Y/Y
                              </th>
                            </React.Fragment>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {leadgenClients.map((clientName) => {
                        return (
                          <tr key={clientName}>
                            <td className="client-cell" style={{ textAlign: "left", fontWeight: "900" }}>
                              {clientName}
                            </td>
                            {[
                              "revenue_mtd",
                              "revenue_mtd_last_year",
                              "revenue_mtd_yy",
                              "revenue_this_month_projected",
                              "revenue_this_month_last_year",
                              "revenue_this_month_yy",
                              "traffic_mtd",
                              "traffic_mtd_last_year",
                              "traffic_mtd_yy",
                              "traffic_this_month_projected",
                              "traffic_this_month_last_year",
                              "traffic_this_month_yy",
                            ].map((metricName) => {
                              let className = "";
                              let value = this.props.metrics[clientName][metricName];
                              if (metricName.includes("yy")) {
                                if (value > 0) {
                                  className = "bg-success text-white font-weight-bold";
                                } else if (value < 0) {
                                  className = "bg-danger text-white font-weight-bold";
                                }
                              }
                              return (
                                <td key={metricName} className={className}>
                                  {value != 0 ? (
                                    metricName.includes("yy") ? (
                                      <MetricFormatter.YY displayCurrency={this.props.currency} value={value} />
                                    ) : metricName.includes("revenue") ? (
                                      <MetricFormatter.Conversions displayCurrency={this.props.currency} value={value} />
                                    ) : (
                                      <MetricFormatter.Sessions value={value} />
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                      <tr>
                        <td className="client-cell" style={{ borderTop: "1px solid darkgrey", textAlign: "left", fontWeight: "900" }}>
                          TOTALS
                        </td>
                        {[
                          "revenue_mtd",
                          "revenue_mtd_last_year",
                          "revenue_mtd_yy",
                          "revenue_this_month_projected",
                          "revenue_this_month_last_year",
                          "revenue_this_month_yy",
                          "traffic_mtd",
                          "traffic_mtd_last_year",
                          "traffic_mtd_yy",
                          "traffic_this_month_projected",
                          "traffic_this_month_last_year",
                          "traffic_this_month_yy",
                        ].map((metricName) => {
                          let className = "";
                          let value = totals["leadgen"][metricName];
                          if (metricName.includes("yy")) {
                            if (value > 0) {
                              className = "bg-success text-white font-weight-bold";
                            } else if (value < 0) {
                              className = "bg-danger text-white font-weight-bold";
                            }
                            className =  value == 0 || value == Infinity || value == -Infinity ? "" : className;
                          }
                          return (
                            <td style={{ borderTop: "1px solid darkgrey" }} key={metricName} className={className}>
                              {value != 0 ? (
                                metricName.includes("yy") ? (
                                  <MetricFormatter.YY displayCurrency={this.props.currency} value={value} />
                                ) : metricName.includes("revenue") ? (
                                  <MetricFormatter.Conversions displayCurrency={this.props.currency} value={value} />
                                ) : (
                                  <MetricFormatter.Sessions value={value} />
                                )
                              ) : (
                                <></>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SEOSummary;
